import { mergeClasses } from "@fluentui/react-components";
import * as React from "react";
import type { Article } from "../data";
import { useStyles } from "./PromptArtItem.web.styles";
import { PromptArtItemFooter } from "./PromptArtItemFooter.web";
export const PromptArtItem: React.FC<{
  article: Article;
  className: string;
}> = ({ article, className }) => {
  const styles = useStyles();
  return (
    <a
      href={article.link}
      target="_blank"
      rel="noreferrer"
      className={mergeClasses(styles.root, className)}
      style={{ backgroundImage: `url("${article.imgSrc}")` }}
      draggable={true}
      onDragStart={(e) => e.preventDefault()}
    >
      <PromptArtItemFooter title={article.title} ctaText={article.ctaText} />
    </a>
  );
};
